import { useNavigate, useParams } from "react-router-dom";
import { CONTACT_TIMELINE_TAKEOVER_BLOCK_ID } from "@tellescope/contact-details";
import { useAppPermissionQuery, useOrgFeatures } from "../../permissions";
import { useCalendarShallowStore } from "../../store";
import { buildCalendarPath } from "../calendar/build-calendar-path";
import { buildContactTimelinePath } from "./build-contact-timeline-path";

const block = { type: "timeline.timeline", info: { id: CONTACT_TIMELINE_TAKEOVER_BLOCK_ID } } as const;

export const useContactTimelineTakeoverPage = () => {
  const navigate = useNavigate();
  const { enduserId } = useParams();
  const { isFeatureEnabled } = useOrgFeatures();
  const { update: updateObservationsPermission } = useAppPermissionQuery({
    model: "enduser_observations",
    actions: ["update"],
  });
  const { lastSelectedViewType, lastSelectedViewId } = useCalendarShallowStore(
    "lastSelectedViewType",
    "lastSelectedViewId"
  );

  const onClose = () => navigate(-1);

  const onOpenTicket = (ticketId: string) => ({ to: `/tickets/details/${ticketId}` });

  const onOpenEvent = (eventId: string, startTimeInMS: number) => ({
    to: `${buildCalendarPath({
      viewType: lastSelectedViewType,
      fallbackViewType: lastSelectedViewType,
      fallbackViewId: lastSelectedViewId,
      date: new Date(startTimeInMS),
    })}?eventId=${eventId}`,
  });

  const onChangeEnduser = (nextEnduserId: string) =>
    navigate(buildContactTimelinePath(nextEnduserId), { replace: true });

  return {
    block,
    enduserId,
    isFeatureEnabled,
    canUpdateObservations: updateObservationsPermission.access,
    onClose,
    onOpenTicket,
    onOpenEvent,
    onChangeEnduser,
  };
};
